<p-button
  [size]="size"
  [outlined]="outlined"
  [rounded]="rounded"
  [raised]="true"
  [severity]="severity"
  [styleClass]="showKeyHint ? styleClass : 'p-button-icon-only ' + styleClass"
  [pTooltip]="showKeyHint ? tooltip : tooltipText"
  tooltipPosition="bottom"
  (onClick)="buttonFunction()">
  <ng-template pTemplate="content">
    <span
      class="p-button-label flex gap-2 align-content-center align-items-center">
      <i class="p-button-icon" [class]="icon"></i>
      @if (label) {
        <span class="mr-3">{{ label }}</span>
      }
      @if (showKeyHint) {
        <span
          class="hidden sm:flex gap-0 align-items-center top-0 right-0 text-xs -mr-2"
          [innerHTML]="keySuffix"></span>
      }
    </span>
  </ng-template>
</p-button>
